import { useEffect, useState } from 'react';

const navLinks = [
  { id: 'ticker', label: '今日爆料' },
  { id: 'latest', label: '最新黑料' },
  { id: 'exclusive', label: '独家爆料' },
  { id: 'stars', label: '明星专区' },
  { id: 'influencers', label: '网红专区' },
  { id: 'timeline', label: '吃瓜时间线' },
  { id: 'ranking', label: '热度榜' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <a
            href="#top"
            className="flex items-center gap-2 cursor-pointer shrink-0"
            aria-label="黑料吃瓜网 首页"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-xl md:text-2xl tracking-wide ${
                  scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                黑料吃瓜网
              </span>
              <span
                className={`text-[10px] tracking-[0.2em] font-label ${
                  scrolled || menuOpen ? 'text-primary-600' : 'text-accent-300'
                }`}
              >
                LATEST · GOSSIP
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1" aria-label="页面分区导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer font-label ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#guide"
              className={`hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                  : 'bg-white/15 text-background-50 hover:bg-white/25'
              }`}
            >
              <i className="ri-question-line" aria-hidden="true"></i>
              吃瓜指南
            </a>
            <button
              type="button"
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
                scrolled || menuOpen ? 'text-foreground-900 hover:bg-background-200' : 'text-background-50 hover:bg-white/15'
              }`}
              aria-label={menuOpen ? '关闭导航菜单' : '打开导航菜单'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <nav className="lg:hidden border-t border-background-200 bg-background-50" aria-label="移动端分区导航">
          <div className="px-4 py-3 grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-800 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer font-label"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#guide"
              onClick={() => setMenuOpen(false)}
              className="col-span-2 px-3 py-2.5 rounded-md text-sm text-secondary-900 bg-secondary-100 hover:bg-secondary-200 transition-colors cursor-pointer font-label"
            >
              吃瓜指南与免责声明
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}